export default __webpack_public_path__ + "static/media/Interregular.e70f22e0.woff";